export const GET_ADMIN_AUDIT_LOGS_REQUEST = "GET_ADMIN_AUDIT_LOGS_REQUEST";
export const GET_ADMIN_AUDIT_LOGS_SUCCESS = "GET_ADMIN_AUDIT_LOGS_SUCCESS";
export const GET_ADMIN_AUDIT_LOGS_FAIL = "GET_ADMIN_AUDIT_LOGS_FAIL";